import { each, sortBy } from 'lodash-es'

// Create children nodes
const createChildren = (paginatedDtoList, parentNode) => {
  const children = []
  each(paginatedDtoList, (child) => {
    // Init children array
    child.children = []
    // Add a link to the parent node
    child.parentNode = parentNode
    // Push child to children array
    children.push(child)
  })

  // Sort by directory first and name
  return sortBy(children, (child) => { return (child.directory ? 0 : 1) + child.name })
}

export default createChildren
